import { KALP_ARALIGI_MS } from "./akademik";

/*
  CANLI CALISMA IZLEME — F-LIV (sartname 4.6b). Panel ile API'nin paylastigi sozlesme.

  Esikler burada, cunku ikisi de okuyor: sunucu siniflandirir, panel "son sinyal X dk once" gibi metinleri ayni
  esiklerle yazar. Iki ayri sabit iki ayri gercek olurdu (`KALP_ARALIGI_MS` ile terk esiginin hikayesi, akademik.ts).
*/

/** Panel listeyi bu aralikla sorgular (F-LIV-04). Websocket YOK. */
export const CANLI_YENILEME_MS = 30_000;

/**
 * Son kalp atisi bundan eskiyse oturum SESSIZ (F-LIV-03): uygulama kapali ya da baglanti yok. Uc kalp araligi: tek bir
 * kacan atis (ag dalgalanmasi) ogrenciyi "sessiz"e dusurmesin.
 */
export const CANLI_SESSIZ_ESIK_MS = 3 * KALP_ARALIGI_MS;

/** Son kalp atisi bundan eskiyse oturum OLU sayilir ve listelenmez (F-LIV-03). */
export const CANLI_OLU_ESIK_MS = 24 * 3_600_000;

/** Baslangicindan bu yana bundan uzun suren oturum "supheli" (unutulmus sayac, F-LIV-03). Otomatik kapatma YOK. */
export const CANLI_SUPHELI_ESIK_MS = 6 * 3_600_000;

/** Listeye en fazla bu kadar satir doner (en yeni kalp atisi once). */
export const CANLI_LISTE_SINIRI = 200;

export type CanliOturumDurumu = "CALISIYOR" | "SESSIZ";

export interface CanliOturumSatiri {
  /** Sayac oturumu kimligi — yalniz liste anahtari; panel bununla hicbir uca gitmez. */
  oturumId: string;
  /** Kayda git baglantisi icin; listeyi goren zaten bu ogrenciyi kapsaminda goruyor. */
  ogrenciId: string;
  /** "Elif Y." — ad + soyadin bas harfi (F-LIV-01; bilgilendirme metni bunu soyluyor). Tam ad DONMEZ. */
  kisaAd: string;
  ders: string;
  /** Konu adi; konusuz gorevde null (panel gorev turunu yazar). */
  konu: string | null;
  /** Gorev turu (`TaskKind`): QUESTION_SOLVING, TOPIC_STUDY, ... */
  gorevTuru: string;
  /** ISO an. */
  baslangic: string;
  /** ISO an. */
  sonSinyal: string;
  durum: CanliOturumDurumu;
  /** CALISIYOR: simdiye kadar; SESSIZ: son kalp atisina kadar (F-STV-06 terk kuraliyla ayni). */
  sureSaniye: number;
  /** Baslangictan bu yana 6 saatten uzun (F-LIV-03). */
  supheli: boolean;
}

export interface CanliListeYaniti {
  /** Sunucunun hesapladigi an (ISO) — panel sureleri bu ana gore yazar. */
  an: string;
  satirlar: CanliOturumSatiri[];
  /** Sinira takildiysa true; panel "ilk 200" der. */
  kesildi: boolean;
}

export interface CanliModulDurumu {
  acik: boolean;
}

/**
 * Bilgilendirme metninin surumu (F-LIV-08). Metin kodda sabit; bu surum degisince metin de degismis demektir.
 * Genel aydinlatma metninin surumu DEGIL — riza istemez, onay kilidini tetiklemez.
 */
export const CANLI_BILGILENDIRME_SURUMU = "3";
